// File: services/recipe.js
import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/admin/cms`;

// export const GetRecipeListApi = async () => {
//   try {
//     const response = await fetch(url, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ data: JSON.stringify({ action: "get" }) }),
//     });

//     if (!response.ok) throw new Error("Failed to fetch recipe list.");
//     return await response.json();
//   } catch (error) {
//     console.error("Fetch error:", error);
//   }
// };

// export const handleDeleteRecipe = async (recipeId, refreshCallback) => {
//   if (window.confirm("Are you sure you want to delete this Recipe?")) {
//     try {
//       const response = await fetch(url, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ data: JSON.stringify({ action: "delete", _id: recipeId }) }),
//       });

//       const data = await response.json();
//       if (data.success) toast.success("Recipe deleted successfully");
//       else toast.warning("Recipe deleted, but response was unexpected");
//       refreshCallback();
//     } catch (error) {
//       console.error("Delete error:", error);
//       toast.error("Something went wrong while deleting.");
//     }
//   }
// };

export const updateCmsApi = async (recipeData) => {
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify({
      action: recipeData._id ? "edit" : "add",
      _id: recipeData._id,
      content: recipeData.content,
      pageType: recipeData.pageType,

    }));

    if (recipeData.imageFile) {
      formData.append("image", recipeData.imageFile);
    }

    const response = await fetch(url, { method: "POST", body: formData });
    const result = await response.json();

    if (result.success || response.status === 201) {
      return result;
    } else {
      toast.error(result.message || "Failed to save recipe");
      return null;
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong while saving the recipe");
    return null;
  }
};

export const getCMSPages = async (type) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: JSON.stringify({ action: "getpages", getPageType: type }) }),
    });

    const result = await response.json();
    if (result.success) return result;
    else toast.error("Failed to load recipe");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
